import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export const FinalCTASection = () => {
  return <section id="comprar" className="py-24 bg-dark relative overflow-hidden" data-id="element-40">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-brand-green/5 blur-[100px] rounded-full pointer-events-none" data-id="element-41"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-42">
        <FadeIn data-id="element-43">
          <h2 className="font-serif text-4xl md:text-5xl font-bold mb-6 text-white" data-id="element-44">
            ¡Empieza Tu Transformación Hoy!
          </h2>
        </FadeIn>
        <FadeIn delay={0.2} data-id="element-45">
          <p className="text-xl text-gray-300 mb-10" data-id="element-46">
            Descarga tu bundle ahora y recarga tu energía desde mañana.
          </p>
        </FadeIn>
        <FadeIn delay={0.4} data-id="element-47">
          <div className="flex flex-col items-center gap-4" data-id="element-48">
            <Button href="https://vitalizateahora.com/cart/51980564005095:1" className="text-xl py-5 px-10 w-full sm:w-auto" data-id="element-49">
              ¡Sí, Quiero Mis 7 Batidos!
            </Button>
            <span className="text-gray-400 font-medium mt-2" data-id="element-50">
              Precio Especial:{' '}
              <span className="text-brand-orange text-xl font-bold" data-id="element-51">
                $9.99 USD
              </span>
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
};